module.exports = __webpack_public_path__ + "static/media/buy_start_service_rent_2.00850480.jpg";